// extracted by mini-css-extract-plugin
export default {"dialog":"UserSelection_tsx_dialog__P8Pr1","container":"UserSelection_tsx_container__vM+Ar"};